var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundGradient1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 586,
    viewBox: "0 0 422 586",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_70_1694)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_70_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.194 141.357C251.329 205.633 176.04 271.909 164.888 309.394C148.393 339.386 161.54 350.499 155.058 380.473C145.004 428.089 123.722 479.231 69.6367 446.181C4.26739 389.374 -27.7935 323.365 -10.1539 277.076C1.51429 234.198 38.6868 193.931 85.1806 178.831C136.043 155.946 259.793 107.994 280.194 141.357Z",
    fill: "#2346FA"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_70_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.926 165.523C158.889 218.565 138.824 255.653 135.009 285.994C126.13 311.06 137.658 318.34 136.482 342.347C134.8 380.459 124.927 422.487 79.1126 402.403C21.5956 365.002 -11.4638 316.965 -3.7768 279.095C-0.250546 244.501 24.5957 218.509 58.4482 201.907C94.6724 178.788 152.989 141.681 172.926 165.523Z",
    fill: "#00D1FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_70_1694)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.515 143.934C128.433 194.1 108.862 229.324 104.805 257.959C96.0208 281.699 106.851 288.389 105.389 311.02C103.242 346.944 93.2695 386.675 50.0993 368.418C-3.92196 334.019 -34.5887 289.248 -26.7496 253.465C-22.9048 220.829 1.04027 195.987 33.3932 179.859C68.0901 157.559 123.946 121.764 142.515 143.934Z",
    fill: "#FF0B80"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M138.475 154.26C128.036 191.448 113.528 217.56 110.521 238.787C104.009 256.385 112.038 261.344 110.953 278.12C109.362 304.751 101.969 334.203 69.9674 320.67C29.9216 295.17 7.18838 261.981 12.9995 235.455C15.8497 211.263 33.6001 192.847 57.5833 180.892C83.304 164.361 124.71 137.826 138.475 154.26Z",
    fill: "#FFFB69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.7 175.788C105.426 198.14 96.706 213.834 94.8983 226.593C90.9844 237.17 95.81 240.151 95.1583 250.234C94.2019 266.241 89.7586 283.943 70.5236 275.809C46.4539 260.482 32.79 240.534 36.2828 224.59C37.9959 210.049 48.6649 198.98 63.0801 191.795C78.5396 181.859 103.427 165.91 111.7 175.788Z",
    fill: "#FFFFFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_70_1694",
    x: -127.963,
    y: 29.9133,
    width: 508.157,
    height: 526.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_70_1694"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_70_1694",
    x: -143.945,
    y: 0.91333,
    width: 553.139,
    height: 584.791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 64.5,
    result: "effect1_foregroundBlur_70_1694"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_70_1694",
    x: -56.8784,
    y: 105.832,
    width: 281.805,
    height: 353.764,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_70_1694"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_70_1694",
    x: -79.9631,
    y: 84.957,
    width: 274.478,
    height: 340.05,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 26,
    result: "effect1_foregroundBlur_70_1694"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGradient1);
export default __webpack_public_path__ + "static/media/background-gradient1.0fc67878b2c7eeac4289faeba584540c.svg";
export { ForwardRef as ReactComponent };